<template>
    <div class="fixed z:$(comment-modal-zindex) w:full h:full flex jc:flex-end top:0 left:0 {pt:36}@<sm" v-if="opened">
        <div class="w:full max-w:414 h:full flex flex-direction:column jc:center bg:white rel {max-w:none;rt:20}@<sm">
            <div class="px:24">
                <div class="f:20 font:bold t:center">檢舉留言</div>
                <div class="my:40 color:#6F737D {mt:24}>div+div">
                    <div>
                        <label class="form-label">選擇檢舉項目</label>
                        <div class="rel">
                            <select2 class="select2-container-in-modal" :options="reasons" placeholder="請選擇" v-if="reasons" v-model="form.reason_id"></select2>
                        </div>
                    </div>
                    <div>
                        <label class="form-label">詳細說明</label>
                        <div>
                            <textarea class="form-control" placeholder="請描述您遇見的問題" rows="5" v-model.trim="form.content"></textarea>
                            <div class="flex jc:end">
                                <form-control-counter :value="form.content?.length" max="1000"></form-control-counter>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="t:center {ml:16}>button+button">
                    <button class="btn btn-outline-secondary" @click="hide" type="button">取消</button>
                    <button class="btn btn-primary" @click="submit" type="button">回報</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        api: { default: "api/comment/list-inform-reason", type: String }
    });

    const form = ref({
        reason_id: null,
        content: null
    });

    const opened = ref(false);
    const reasons = ref();

    const emit = defineEmits(["submit"]);

    const hide = () => {
        form.value.reason_id = null;
        form.value.content = null;

        opened.value = false;
    }

    const show = () => {
        if (reasons.value) {
            opened.value = true;
        } else {
            api(props.api).done((res) => {
                if (res.success) {
                    reasons.value = res.data;
                    opened.value = true;
                }
            });
        }
    }

    const submit = () => {
        if (form.value.reason_id && form.value.content) {
            emit("submit", form.value);
        }
    };

    defineExpose({ hide, show });
</script>
